module.exports = __webpack_public_path__ + "static/img/5-CN.2b94c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m/5-CN.png
// module id = SibG
// module chunks = 1